import { IGif } from "@/common/services/types";
import { useCallback, useState } from "react";

export const useGalleryGif = (gif: IGif) => {
  const [currentGalleryGif, setCurrentGalleryGif] = useState<IGif | null>(gif.gallery ? gif : null);
  const [galleryImages, setGalleryImages] = useState<number>(0);

  const onSetGalleryImages = useCallback((qty: number) => {
    setGalleryImages(qty);
  }, []);

  const onSetGalleryGif = useCallback((gif: IGif) => {
    setCurrentGalleryGif(gif);
  }, []);

  return {
    currentGalleryGif,
    galleryImages,
    onSetGalleryImages,
    onSetGalleryGif
  };
};
